var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"team_map"}},[_c('f7-navbar',{attrs:{"title":"Sessions","back-link":"Back"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }